import React from 'react';
import { Navigate } from 'react-router-dom';
import { storageMgt } from '../utils/storage';
import { ROUTES } from '../data/routes';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const isAuth = storageMgt.isAuthenticated();
  const user = storageMgt.getUser();

  if (!isAuth || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
